function stringToColor(string) {
  let hash = 0;
  let i;

  /* eslint-disable no-bitwise */
  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = '#';

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.slice(-2);
  }
  /* eslint-enable no-bitwise */

  return color;
}

export function stringAvatar(name = 'Unknown', resolution = {}) {
  let cleanName = name.replace(/\(.*?\)/g, '').trim(); // Remove any parentheses
  let s = cleanName.split(' ');
  let initials = s[0].charAt(0).toUpperCase();
  if (s.length > 1) {
    initials += s[1].charAt(0).toUpperCase();
  }
  return {
    sx: {
      bgcolor: stringToColor(name),
      width: Math.min(resolution.width, 100),
      height: Math.min(resolution.height, 100),
    },
    children: initials,
  };
}
